import { appstr } from "@coreapp/utils/appstr";
import { AssignmentStatus } from "@coreapp/constants";
import { CircularIcon, Icon, isNullish } from "@theorgchartdev/storybook";

export type EmployeeDetailIconProps = {
  variant?: ValueOf<typeof AssignmentStatus>;
};

export const EmployeeDetailIcon = (props: EmployeeDetailIconProps) => {
  if (isNullish(props.variant)) {
    return null;
  }

  const { appstrKey, modifier, color, name } = (
    {
      [AssignmentStatus.Assigned]: {
        appstrKey: "Assigned",
        modifier: "warning",
        color: "warning",
        name: "user-solid"
      },
      [AssignmentStatus.Unassigned]: {
        appstrKey: "Unassigned",
        modifier: "success",
        color: "success",
        name: "user-plus"
      },
      [AssignmentStatus.Released]: {
        appstrKey: "Released",
        modifier: "secondary",
        color: "secondary",
        name: "user-slash"
      },
      [AssignmentStatus.AssignedOutOfScope]: {
        appstrKey: "Assigned Out Of Scope Info",
        modifier: "purple",
        color: "purple",
        name: "solid-user-circle-arrow-right"
      }
    } as any
  )[props.variant];

  return (
    <div className="oc-shrink-0" title={appstr(appstrKey).toLocaleLowerCase()}>
      <CircularIcon color={color} size="small">
        <Icon name={name} modifier={modifier} size="small" />
      </CircularIcon>
    </div>
  );
};
